import { getAge } from "./datetime";
import { getGender } from "./strings";

export function getSupportId() {
    try {
        if (typeof window !== "undefined" && "Goftino" in window) {
            return window.Goftino.getUserId();
        }
    } catch {}

    return null;
}

export function setSupportId(supportId) {
    try {
        if (typeof window !== "undefined" && "Goftino" in window) {
            window.Goftino.setUserId(supportId, () => {
                console.debug("successfully set user supportId in goftino");
            });
        }
    } catch {}
}

export function setSupportUser(profile) {
    try {
        if (typeof window !== "undefined" && "Goftino" in window) {
            const userData = getNormalizedUserForSupport("Goftino", profile);
            window.Goftino.setUser(userData);
        }
    } catch {}
}

export function unsetSupportId() {
    try {
        if (typeof window !== "undefined" && "Goftino" in window) {
            console.debug("-- unset goftino user id --");
            window.Goftino.unsetUserId();
        }
    } catch {}
}

export function getNormalizedUserForSupport(widgetType, profile) {
    const result = {
        name: `${profile.firstName} ${profile.lastName}`,
        phone: profile.studentNumber,
        about: "-",
        tags: widgetType === "OnlineHawzahChatWidget" ? "workflow" : "class",
        metadata: [{ key: "جنسیت", value: getGender(profile?.gender) }],
        forceUpdate: true,
    };

    if (profile?.birthYear) {
        result.metadata.push({ key: "سن", value: getAge(profile?.birthYear) });
    }

    if (profile?.eduType) {
        const eduType = profile?.eduType;
        let text = "";
        if (eduType === "S") {
            text = "سیکل و قبل از آن";
        } else if (eduType === "D") {
            text = "دیپلم";
        } else if (eduType === "U") {
            text = "دانشگاهی";
        } else if (eduType === "H") {
            text = "حوزوی";
        } else if (eduType === "UH") {
            text = "دانشگاهی و حوزوی";
        }
        result.metadata.push({ key: "نوع تحصیلات", value: text });
    }

    if (profile?.degree) {
        result.metadata.push({ key: "مقطع تحصیلی", value: profile?.degree });
    }

    if (profile?.hawzahEdu) {
        result.metadata.push({ key: "سال حوزه", value: profile?.hawzahEdu });
    }

    return result;
}
